"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftRatingMetricQuestionsDto = instanceOfShiftRatingMetricQuestionsDto;
exports.ShiftRatingMetricQuestionsDtoFromJSON = ShiftRatingMetricQuestionsDtoFromJSON;
exports.ShiftRatingMetricQuestionsDtoFromJSONTyped = ShiftRatingMetricQuestionsDtoFromJSONTyped;
exports.ShiftRatingMetricQuestionsDtoToJSON = ShiftRatingMetricQuestionsDtoToJSON;
exports.ShiftRatingMetricQuestionsDtoToJSONTyped = ShiftRatingMetricQuestionsDtoToJSONTyped;
const runtime_1 = require("../runtime");
const ShiftRatingMetricQuestionsDtoMetricsValue_1 = require("./ShiftRatingMetricQuestionsDtoMetricsValue");
/**
 * Check if a given object implements the ShiftRatingMetricQuestionsDto interface.
 */
function instanceOfShiftRatingMetricQuestionsDto(value) {
    if (!('metrics' in value) || value['metrics'] === undefined)
        return false;
    return true;
}
function ShiftRatingMetricQuestionsDtoFromJSON(json) {
    return ShiftRatingMetricQuestionsDtoFromJSONTyped(json, false);
}
function ShiftRatingMetricQuestionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'metrics': ((0, runtime_1.mapValues)(json['metrics'], ShiftRatingMetricQuestionsDtoMetricsValue_1.ShiftRatingMetricQuestionsDtoMetricsValueFromJSON)),
    };
}
function ShiftRatingMetricQuestionsDtoToJSON(json) {
    return ShiftRatingMetricQuestionsDtoToJSONTyped(json, false);
}
function ShiftRatingMetricQuestionsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'metrics': ((0, runtime_1.mapValues)(value['metrics'], ShiftRatingMetricQuestionsDtoMetricsValue_1.ShiftRatingMetricQuestionsDtoMetricsValueToJSON)),
    };
}
//# sourceMappingURL=ShiftRatingMetricQuestionsDto.js.map